export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";

export const SET_SUB_PERMISSIONS = "SET_SUB_PERMISSIONS";

export const SET_IS_SUPER_ADMIN = "SET_IS_SUPER_ADMIN";

export const SET_USER_PERMISSION_LOADING = "SET_USER_PERMISSION_LOADING";
